import { Intent } from '@reapit/elements'

export const documentStatusMapping: { [key: string]: string } = {
  None: 'None',
  Draft: 'Draft',
  Pending: 'Pending',
  Blocked: 'Blocked',
  Expired: 'Expired',
  Signed: 'Signed',
  Closed: 'Closed',
}

export const documentStatusIntent: { [key: string]: Intent } = {
  None: 'default',
  Draft: 'default',
  Pending: 'neutral',
  Blocked: 'warning',
  Expired: 'danger',
  Signed: 'success',
  Closed: 'default',
}
